import { REWARDS_CATALOG } from '../lib/constants.js';
import { goalProgress } from '../lib/helpers.js';
import { Btn } from './Basic.jsx';
import { t as tr } from '../lib/i18n.js';
export function SettingsRow({icon,label,sub,onClick,danger,right,t}){
  return(
    <div onClick={onClick} style={{display:"flex",alignItems:"center",gap:12,padding:"13px 4px",cursor:onClick?"pointer":"default",borderBottom:`1px solid ${t?t.bord:"rgba(0,0,0,.06)"}`}}>
      <div style={{width:32,fontSize:17,textAlign:"center",flexShrink:0}}>{icon}</div>
      <div style={{flex:1}}>
        <div style={{fontSize:14,fontWeight:600,color:danger?"#D93025":(t?t.tx:"#1a1a1a"),fontFamily:"Inter,sans-serif"}}>{label}</div>
        {sub&&<div style={{fontSize:11,color:t?t.soft:"#888",fontFamily:"Inter,sans-serif",marginTop:2}}>{sub}</div>}
      </div>
      {right!==undefined?right:(onClick&&<div style={{fontSize:14,color:t?t.soft:"#bbb"}}>›</div>)}
    </div>
  );
}
export function GoalProgressRow({goal,metrics,claimed,onClaim,t}){
  const p=goalProgress(goal,metrics);
  const reward=goal.reward&&REWARDS_CATALOG.find(r=>r.id===goal.reward);
  const isClaimed=claimed.includes(goal.id);
  return(
    <div style={{background:t?t.card:"#fff",borderRadius:13,padding:"12px 14px",border:`1px solid ${t?t.bord:"rgba(0,0,0,.07)"}`,marginBottom:9}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
        <span style={{fontSize:12.5,fontWeight:600,color:t?t.tx:"#1a1a1a",fontFamily:"Inter,sans-serif",flex:1}}>{goal.label}</span>
        <span style={{fontSize:11,color:p.done?"#2D6A4F":(t?t.soft:"#999"),fontFamily:"Inter,sans-serif",fontWeight:700,marginLeft:8}}>{p.value}/{p.target}</span>
      </div>
      <div style={{height:6,background:t?t.bord:"rgba(0,0,0,.07)",borderRadius:3,overflow:"hidden",marginBottom:reward?8:0}}>
        <div style={{height:"100%",width:`${(p.value/p.target)*100}%`,background:p.done?"linear-gradient(90deg,#2D6A4F,#52B788)":"linear-gradient(90deg,#FF2D6B,#7B2FFF)",borderRadius:3,transition:"width .4s"}}/>
      </div>
      {reward&&(
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <span style={{fontSize:16}}>{reward.emoji}</span>
            <div style={{display:"flex",flexDirection:"column"}}>
              <span style={{fontSize:10.5,color:t?t.soft:"#888",fontFamily:"Inter,sans-serif"}}>{reward.name}</span>
              <span style={{fontSize:9,color:t?t.soft:"#aaa",fontFamily:"Inter,sans-serif",opacity:.8}}>{tr(`reward_usage_${reward.type}`)}</span>
            </div>
          </div>
          {p.done&&!isClaimed&&<Btn fn={()=>onClaim(goal)} style={{padding:"5px 13px",borderRadius:20,background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:"#fff",fontSize:10.5,fontWeight:700,fontFamily:"Inter,sans-serif",flexShrink:0}}>{tr("shared_claim_cta")}</Btn>}
          {isClaimed&&<span style={{fontSize:10,color:"#2D6A4F",fontFamily:"Inter,sans-serif",fontWeight:700,flexShrink:0}}>{tr("shared_claimed_label")}</span>}
        </div>
      )}
    </div>
  );
}
